// Analytics helper — wraps GA4 (optional env var) + Meta Pixel (installed in index.html)
// Every CTA click should call trackRegisterClick(source) to record conversion funnel.

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "997901033669346";

/**
 * Lazy-initialize GA4 if an ID is provided via env var.
 * Safe to call multiple times.
 */
export function initGA4() {
  if (!GA4_ID || typeof window === "undefined") return;
  if (window.__ga4_initialized) return;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { send_page_view: true });
  window.__ga4_initialized = true;
}

/**
 * Generic event tracker — fans out to GA4 + Meta Pixel (via fbq already loaded in index.html).
 */
export function trackEvent(name, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) window.fbq("trackCustom", name, params);
  } catch (e) {
    // swallow analytics errors silently — never break UX
    console.warn("[analytics] track failed", e);
  }
}

/**
 * Canonical CTA conversion tracker.
 * @param {string} source - location of the click (e.g. 'header', 'hero', 'products', 'final-cta', 'mobile').
 */
export function trackRegisterClick(source) {
  trackEvent("register_click", { source });
  // Meta Pixel standard "Lead" event for conversion optimization campaigns
  try {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "Lead", { source });
    }
  } catch (_) {}
}

export const CONFIG = { GA4_ID, META_PIXEL_ID };
